// @flow
import Vue from 'vue'

/**
 * Require and code split / lazy load search related components
 *
 * Also contains
 * - custom workout form components
 * - routine builder components
 * - plans scheduling
 * - product cards (gift card)
 *
 * This is because there is a lot of overlap and both routines / custom workouts / plans
 * that leverage "search" capabilities, so made sense to bundle here vs tons of smaller
 * code splitting.
 *
 * If they grow, we can split into separate chunks.
 */
const searchCodeSplit = () => {
  /* CARDS */

  Vue.component('video-card', () =>
    import(/* webpackChunkName: "search" */ '../components/videos/video-card.vue'),
  )
  Vue.component('article-card', () =>
    import(/* webpackChunkName: "search" */ '../components/articles/article-card.vue'),
  )
  Vue.component('wellness-video-card', () =>
    import(
      /* webpackChunkName: "search" */ '../components/wellness-videos/wellness-video-card.vue'
    ),
  )
  // plan-card in main app.js

  /* ROUTINES */
  // routines are apart of the search chunk as they use video / favorites pages
  Vue.component('routine-info-form', () =>
    import(/* webpackChunkName: "search" */ '../components/routines/routine-info-form.vue'),
  )
  Vue.component('routine-meta-data', () =>
    import(/* webpackChunkName: "search" */ '../components/routines/routine-meta-data.vue'),
  )
  Vue.component('routine-instructions-carousel', () =>
    import(
      /* webpackChunkName: "search" */ '../components/routines/routine-instructions-carousel.vue'
    ),
  )

  /* PLANS */
  Vue.component('plan-schedule-grid', () =>
    import(
      /* webpackChunkName: "search" */ '../components/plans/plan-schedule/plan-schedule-grid.vue'
    ),
  )
  Vue.component('reschedule-form', () =>
    import(/* webpackChunkName: "search" */ '../components/plans/reschedule-form.vue'),
  )
  Vue.component('energy-card', () =>
    import(/* webpackChunkName: "search" */ '../components/users/settings/energy/energy-card.vue'),
  )
  Vue.component('shopping-list', () =>
    import(/* webpackChunkName: "search" */ '../components/plans/shopping-list.vue'),
  )
  Vue.component('my-program-carousel', () =>
    import(/* webpackChunkName: "search" */ '../components/carousels/my-program-carousel.vue'),
  )
  Vue.component('meal-plans-carousel', () =>
    import(/* webpackChunkName: "search" */ '../components/carousels/meal-plans-carousel.vue'),
  )

  /* CUSTOM WORKOUTS */
  Vue.component('custom-workout-form', () =>
    import(
      /* webpackChunkName: "search" */ '../components/custom-workouts/custom-workout-form.vue'
    ),
  )

  /* ARTICLES */
  Vue.component('recipe-meta-data', () =>
    import(/* webpackChunkName: "search" */ '../components/articles/recipe-meta-data.vue'),
  )
  Vue.component('recipe-energy-card', () =>
    import(/* webpackChunkName: "search" */ '../components/articles/recipe-energy-card.vue'),
  )

  /* PRODUCTS */
  Vue.component('gift-card', () =>
    import(/* webpackChunkName: "search" */ '../components/products/gift-card.vue'),
  )
  Vue.component('pass-card', () =>
    import(/* webpackChunkName: "search" */ '../components/products/pass-card.vue'),
  )

  /* TEAM MEMBER */
  Vue.component('team-member-card', () =>
    import(/* webpackChunkName: "search" */ '../components/team-members/team-member-card.vue'),
  )
  Vue.component('recent-article-widget', () =>
    import(/* webpackChunkName: "search" */ '../components/team-members/recent-article-widget.vue'),
  )
  Vue.component('recent-workout-widget', () =>
    import(/* webpackChunkName: "search" */ '../components/team-members/recent-workout-widget.vue'),
  )
  Vue.component('recent-wellness-video-widget', () =>
    import(
      /* webpackChunkName: "search" */ '../components/team-members/recent-wellness-video-widget.vue'
    ),
  )
}

export default searchCodeSplit
